import Configuracao from "../misc/Configuracao";
import fetch from "./AxiosAdapter";

class DocumentoApi {
async buscarPecasFiltradas(idProcesso: number, idspecas: number[]) {
        const result = await fetch(Configuracao.urlPecasFiltradas.replace('{IDPROCESSO}', idProcesso.toString()), {
            method: 'POST',
            body: idspecas,
            responseType: "blob",
        });
        return result.data;
}
}

export default new DocumentoApi();